import type { BillingViewModel } from "@lumora/core";
import { useViewModel } from "@lumora/ui";

export interface BillingSectionProps {
  viewModel: BillingViewModel;
  onStartHosting?: (() => void) | undefined;
}

/** BillingSection renders the Stripe billing-portal redirect button. Pure view — no logic. */
export function BillingSection({ viewModel, onStartHosting }: BillingSectionProps) {
  const state = useViewModel(viewModel);
  const unconfigured = viewModel.unconfiguredNotice();

  return (
    <section className="portal-section" data-lumora-view="billing">
      <h2>Billing</h2>
      {state.error ? <p data-lumora-error className="portal-error">{state.error}</p> : null}
      {unconfigured ? (
        <p data-lumora-billing-unconfigured>{unconfigured}</p>
      ) : state.status ? (
        <p>
          {state.status.hostingActive
            ? "Hosting active"
            : "Hosting payment needed — choose a plan to set up payment and activate hosting in one step"}
          {state.status.hostingWaivedUntil
            ? ` · waived through ${new Date(state.status.hostingWaivedUntil).toLocaleDateString()}`
            : ""}
        </p>
      ) : state.statusLoading ? (
        <p>Loading billing status…</p>
      ) : null}
      {viewModel.waiverNotice() ? <p data-lumora-waiver-expiry>{viewModel.waiverNotice()}</p> : null}
      {!unconfigured && state.status?.needsPayment && onStartHosting ? (
        <button
          type="button"
          className="portal-btn"
          data-lumora-start-hosting
          onClick={onStartHosting}
        >
          Choose Hosting Plan
        </button>
      ) : null}
      {!unconfigured && state.status?.canManageBilling ? (
        <button
          type="button"
          className="portal-btn"
          disabled={state.loading}
          onClick={() => void viewModel.openPortal(window.location.href)}
        >
          {state.loading
            ? "Redirecting…"
            : state.status.hasStripeSubscription
              ? "Manage Billing"
              : "Set Up Payment Method"}
        </button>
      ) : null}
    </section>
  );
}
